import $ from 'jquery';

export default function photoSliderProf() {
    $('.text-photo-slider-panel_top_input').on('change', (e: JQuery.ChangeEvent) => {
        if ($(e.target).val() === '') {
            $('.js-panel-' + e.target.dataset.idPanel).fadeIn();
        } else {
            $('.js-panel-' + e.target.dataset.idPanel).hide();
            $('.js-cat-' + $(e.target).val()).fadeIn();
        }
        $('.text-photo-slider-panel_wrp').each((index: number, ele: any) => {
            ele.swiper.update();
        });
    });
}
